import * as React from 'react';
import {getTestmodeLogger} from '../getLogger';
import {useAuthContext} from '../../data-layer-client/AuthContext/AuthContext';
import {useSupplementalObject} from '../../data-layer-client/SupplementalObjectContext/SupplementalObjectContext';
import type {IConnectElementSupplementalObject} from '../../connect/ConnectElementSupplementalObjects';
import type {ConnectElementImportKeys} from '../../connect/ConnectJSInterface/ConnectElementList';

/**
 * Used to log a warning whenever a supplemental object is changed after the initial render
 */
export const useWarnOnChangingParameterAfterInitialRender = (
  supplementalObjectName: string,
  getValue: (obj: IConnectElementSupplementalObject) => any,
  connectElementName: ConnectElementImportKeys,
) => {
  const supplementalObjects = useSupplementalObject();
  const objValue = getValue(supplementalObjects);
  const [initialValue] = React.useState(objValue);
  const {authInfo} = useAuthContext();

  React.useEffect(() => {
    if (initialValue !== objValue && authInfo?.livemode !== undefined) {
      getTestmodeLogger(!authInfo?.livemode).warn(
        `Parameter '${supplementalObjectName}' on component '${connectElementName}' has changed from '${initialValue}' to '${objValue}'. Note this parameter can only be specified before the component mounts. Subsequent value updates are ignored.`,
      );
    }
  }, [
    objValue,
    supplementalObjectName,
    initialValue,
    authInfo?.livemode,
    connectElementName,
  ]);
};
